var facebookAPI = (function() {

	var facebookArray = []; 

	return {

		checkLogin: function(){

			var urlCheckLogin = '//social.rvsitebuilder.com/facebook/checkStatus.php';
			var frameGetStatus = '<iframe id="checkStatusFacebook" src="" width="100%" height="300" style="display:none;"></iframe>';

			$('#frameBody').after(frameGetStatus);
			$('#checkStatusFacebook').attr("src", urlCheckLogin);
			setTimeout(function(){ $('#checkStatusFacebook').remove(); },5000);

			return true;
		},

		login: function(){

			var urlCheckLogin = '//social.rvsitebuilder.com/facebook/loginFacebook.php';
			var frameGetStatus = '<iframe id="loginFacebook" src="" width="100%" height="300" style="display:none;"></iframe>';

			$('#frameBody').after(frameGetStatus);
			$('#loginFacebook').attr("src", urlCheckLogin);
		},

		logout: function(){

			var urlCheckLogin = '//social.rvsitebuilder.com/facebook/logoutFacebook.php';
			var frameGetStatus = '<iframe id="loginFacebook" src="" width="100%" height="300" style="display:none;"></iframe>';

			$('#frameBody').after(frameGetStatus);
			$('#loginFacebook').attr("src", urlCheckLogin);

		},
		openphoto: function(){
			$('button#image').click();
			$('#loginFacebook').remove();

			/*
		var facebookPhoto;
		var fBody =  $('#frameBody').contents();
		var widthframe = "900";
		var heightframe = "600";
		var url = 'http://social.rvsitebuilder.com/facebook/facebookPhoto.html';
		$(RVwys.currentiFrame).focus();
		fBody.find('.layoutResize').remove().end();

		if(facebookPhoto) {
			facebookPhoto.focus();
			if (facebookPhoto.closed) {
				facebookPhoto = window.open(url, 'facebookPhoto', 'height='+heightframe+',width='+widthframe+',toolbar=0,top=100');
				facebookPhoto.focus();
			}
		} else {
			facebookPhoto = window.open(url, 'facebookPhoto', 'height='+heightframe+',width='+widthframe+',toolbar=0,top=100');
			facebookPhoto.focus();
		}
			 */
		}

	}
}());

window.addEventListener("message",function (e) { 
	
	var eData = e.data;
	
	if(eData[1] == "facebook"){
		
		switch(eData[0]){
		
		case 'openImage':
			console.log(eData[0]);
			facebookAPI.openphoto();
			break;
		case 'openLogin':
			facebookAPI.login();
			break;
		default:
			console.log('Not Defined');
		
		}
		
	}
}, false);

